import * as yup from 'yup'

export const buildMessageTemplateSchema = (
  t: (word: string, variables?: Record<string, unknown>) => string,
) =>
  yup.object({
    logo: yup.mixed().nullable().optional(),
    deadlineDays: yup.mixed().nullable().optional(),
    subject: yup
      .string()
      .required(t('Campo requerido!'))
      .max(60, t('Máximo 60 caracteres!')),
    body: yup
      .string()
      .required(t('Campo requerido!'))
      .max(1024, t('Máximo 1024 caracteres!')),
    footer: yup
      .string()
      .max(60, t('Máximo 60 caracteres!'))
      .nullable()
      .optional(),
    buttonLabel: yup
      .string()
      .max(60, t('Máximo 60 caracteres!'))
      .when('channel', {
        is: 'email',
        then: (currentSchema) => currentSchema.required(t('Campo requerido!')),
      }),
    channel: yup.string(),
    type: yup.string().required(t('Campo requerido!')),
  })

export const MessageTemplateSchema = buildMessageTemplateSchema((word) => word)

export interface IMessageTemplateSchema
  extends yup.InferType<typeof MessageTemplateSchema> {}
